export function toBoolean(value: boolean | string): boolean {
  return value === '' || (value && value !== 'false');
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/@hornbillfx/components/util/convert.ts